/**
 * Renders steps fields based on the provided formData object.
 *
 * @param {{ key: {
 *     data: string,
 *     label: string,
 *     type: string,
 * }}} [formData] - The steps data object.
 * @param {Object} [styles] - The styles for the label and field value.
 * @param {string} [styles.label] - The styles for the label.
 * @param {string} [styles.fieldValue] - The styles for the field value.
 * @returns {Array} - An array of JSX elements representing the steps fields.
 */
const OtherFormFields = ({
  formData,
  styles = { label: "", fieldValue: "", spacingToDescription: "" },
}) => {
  const specialFields = [
    "title",
    "upload",
    "coverImage",
    "tags",
    "type",
    "description",
  ];

  const allowedTypes = ["multiLine", "singleLine", "selection"];

  const fields = Object.keys(formData).map((fieldKey) => {
    // Skip if it's a special field or the value of this field is null or it's not a text field.
    if (
      specialFields.includes(fieldKey) ||
      !formData[fieldKey].data ||
      !allowedTypes.includes(formData[fieldKey].type)
    ) {
      return null;
    }

    return (
      <section
        className={styles.mainInfoCol}
        key={fieldKey.toString()}
        aria-labelledby={`label-${fieldKey}`}
      >
        <h2 id={`label-${fieldKey}`} className={styles.label}>
          {formData[fieldKey].label}
        </h2>
        <p className={styles.fieldValue}>{formData[fieldKey].data}</p>
      </section>
    );
  });

  return (
    <>
      {fields}
      <span className={styles.spacingToDescription} />
    </>
  );
};

export default OtherFormFields;
